import posthog from 'posthog-js';
import { isAppPWA } from '../utils/helper-functions';
import { calculateTotalToPay } from '../utils/order/orderUtils';

export const posthogOrderCaptureEvent = (orderData, captureEvent) => {

  const eventData = {
    order_id: orderData?._id,
    user_id: orderData?.userId,
    items_count: orderData?.orderItems?.length || 0,
    total_amount: calculateTotalToPay(orderData.itemsPrice, orderData.promoPrice, orderData?.jackpot?.amount) || 0,
    has_promo: !!orderData?.promoprice,
    replay_marker: `Commande - ${orderData?._id}`,
    store: orderData?.storeId,
    is_pwa: isAppPWA(),
    is_paid: orderData?.isPaid,
    paid_at: orderData?.paidAt,
    payment_method: orderData?.paymentMethod,
    is_verified: orderData?.verification,
    verification_at: orderData?.verifiedAt,
    is_manually_verified: orderData?.manualVerification,
    manually_verified_at: orderData?.manualVerificationAt,
    timestamp: new Date().toISOString(),
    ...(captureEvent && { [`${captureEvent}_timestamp`]: new Date().toISOString() }),

  };

  try {
    posthog.capture(captureEvent, eventData);
  } catch (error) {
    console.error('PostHog capture failed:', error);
  }
};

export const posthogOrderGroupEvent = (groupEvent, status, orderData) => {

  const eventData = {
    order_id: orderData?._id,
    order_user_id: orderData?.userId,
    order_fid_card_number: orderData?.fidCardNumber,
    order_entry_qr: orderData?.entryQr,
    order_email: orderData?.email,
    status: status,
    items_count: orderData?.orderItems?.length || 0,
    total_amount: calculateTotalToPay(orderData.itemsPrice, orderData.promoPrice, orderData?.jackpot?.amount) || 0,
    store: orderData?.storeId,
    is_pwa: isAppPWA(),
    is_paid: orderData?.isPaid,
    paid_at: orderData?.paidAt,
    payment_method: orderData?.paymentMethod,
    is_verified: orderData?.verification,
    verification_at: orderData?.verifiedAt,
    is_manually_verified: orderData?.manualVerification,
    manually_verified_at: orderData?.manualVerificationAt,
    timestamp: new Date().toISOString(),
    order_created_at: orderData?.createdAt,
    order_paid_at: orderData?.paidAt,
    order_verification_at: orderData?.verifiedAt,
    order_manually_verified_at: orderData?.manualVerificationAt,
    order_updated_at: orderData?.updatedAt,

  };

  try {
    posthog.group(groupEvent, orderData?._id, eventData);
  } catch (error) {
    console.error('PostHog capture failed:', error);
  }
};
